import { Container } from './ListEquipmentsTag.styles';

const ListEquipmentsTagError = () => {
  return <Container>Error on load products</Container>;
};

export { ListEquipmentsTagError };
